import { ReportAPI } from 'api'
import { mapResponse } from 'utils/api'

import { IUserActivitySummary } from '../types'

export const fetchAvailabilityData = (
  queryConfig
): Promise<IUserActivitySummary> =>
  ReportAPI.get(
    `/user-activity/fetchByOrg?start=${queryConfig.startDate}&end=${queryConfig.endDate}`
  ).then(mapResponse)
